import type { SvgIconProps } from './types';

export function Heart({
  className,
  pathProps,
}: SvgIconProps & {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Heart</title>
      <path
        d="M10 16.875C10 16.875 2.1875 12.5 2.1875 7.18751C2.1875 6.24836 2.51289 5.33821 3.1083 4.61193C3.70371 3.88564 4.53236 3.38808 5.45328 3.2039C6.37419 3.01971 7.33047 3.16029 8.15943 3.6017C8.98838 4.04311 9.63879 4.7581 10 5.62501C10.3612 4.7581 11.0116 4.04311 11.8406 3.6017C12.6695 3.16029 13.6258 3.01971 14.5467 3.2039C15.4676 3.38808 16.2963 3.88564 16.8917 4.61193C17.4871 5.33821 17.8125 6.24836 17.8125 7.18751C17.8125 12.5 10 16.875 10 16.875Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </svg>
  );
}

export function HeartStraight({
  className,
}: SvgIconProps & {
  className?: string;
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Heart Straight</title>
      <path
        d="M8.35634 13.2429L13.4188 8.18036C14.6626 6.93036 14.8438 4.88661 13.6688 3.58036C13.3742 3.25118 13.0155 2.98554 12.6146 2.79966C12.2138 2.61379 11.7793 2.51159 11.3377 2.4993C10.8961 2.48702 10.4566 2.56491 10.046 2.72822C9.63552 2.89152 9.26261 3.13682 8.95009 3.44911L8.00009 4.40536L7.18134 3.58036C5.93134 2.33661 3.88759 2.15536 2.58134 3.33036C2.25215 3.62504 1.98651 3.98374 1.80064 4.38455C1.61476 4.78535 1.51256 5.21985 1.50028 5.66149C1.488 6.10313 1.56589 6.54264 1.72919 6.95316C1.8925 7.36368 2.13779 7.73659 2.45009 8.04911L7.64384 13.2429C7.73863 13.3367 7.86666 13.3894 8.00009 13.3894C8.13351 13.3894 8.26154 13.3367 8.35634 13.2429V13.2429Z"
        stroke="#808080"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
